import { StepConfig } from '../../dynamicForm/types/fieldTypes';

export const photosStep: StepConfig = {
  title: 'Photos',
  description: 'Add photos to showcase your vehicle',
  sections: [
    {
      title: 'Pictures',
      fields: [
        {
          name: 'images',
          type: 'imageUpload',
          label: 'Photos',
          required: false,
          layout: { span: 24 },
          customProps: {
            maxFiles: 15,
            maxFileSize: 10,
            acceptedFormats: ['jpg', 'jpeg', 'png', 'webp', 'heic'],
            placeholder: 'Select images or drag & drop',
            helpText: '0 of 15 images (max. 10 MB per image)',
            tipsLink: 'Tips for pictures',
          },
        },
      ],
    },
  ],
  footer: {
    buttons: [
      {
        label: 'Back',
        action: 'back',
        position: 'left',
        variant: 'secondary',
        icon: 'bi-arrow-left',
      },
      {
        label: 'Next: Location',
        action: 'next',
        position: 'right',
        variant: 'primary',
        icon: 'bi-arrow-right',
      },
    ],
  },
};
